import { Empty, Modal } from "antd";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

//STYLE
import { Tabela } from "./style";

//APP
import { removerAcentos } from "../../../../../../utils";
import { TypeTabelaMapaResumido } from "../../meta";
import { ResultadoAnaliseOS__Item } from "../../../../../../services/AgriculturaPrecisao/bookResumido/GET";

//COMPONENT
import Input from "../../../../../../Components/CustomUi/input";
import Carregando from "../../../../../../Components/CustomUi/loading";
import SvgAgrupados from "../../../../../../Components/CustomUi/talhaSvgAgrupado";
import ButtonCustom from "../../../../../../Components/ButtonCustom";
import { Render } from "../../../../../../Components/CustomUi/render";
import { RowItem } from "../../../../../../Components/CustomUi/table/rowItem";
import { RowTable } from "../../../../../../Components/CustomUi/table/rowTable";
import { BodyTable } from "../../../../../../Components/CustomUi/table/bodyTable";
import { HeaderBook } from "../headerBook";
import { HeaderTable } from "../../../../../../Components/CustomUi/table/headerTable";
import { DrawerCustom } from "../../../../../../Components/CustomUi/Drawer";
import { BookFertilidadeResumidoSeparado } from "./components/bookFertilidadeResumidoSeparado";
import { ModalGerarBookFertilidadeResumido } from "./components/modalGerar";

//PROPS
interface Props {
    lista_propriedades: TypeTabelaMapaResumido[];
    carregando_pedidos: boolean;
}

export const TabelaMapaFertilidadeResumido: React.FC<Props> = ({ lista_propriedades, carregando_pedidos }) => {

    //STATES
    const [buscar_propriedade, setBuscar_propriedade] = useState<string>('');
    const [open_modal, setOpen_modal] = useState<boolean>(false);
    const [cod_propriedade_selecionada, setCod_propriedade_selecionada] = useState<number>(null);
    const [nome_propriedade_selecionada, setNome_propriedade_selecionada] = useState<string>('');
    const [talhoes_selecionados, setTalhoes_selecionados] = useState([]);
    const [open_gaveta_book, setOpen_gaveta_book] = useState<boolean>(false);
    const [exibir_terreno, setExibir_terreno] = useState<boolean>(true);
    const [lista_dados_os, setLista_dados_os] = useState<ResultadoAnaliseOS__Item[]>([]);
    const [nome_calcario_propriedade, setNome_calcario_propriedade] = useState<string>('');
    const [cods_elementos_selecionados, setCods_elementos_selecionados] = useState<number[]>([]);
    const [profundidades_filtrar_selecionadas, setProfundidades_filtrar_selecionadas] = useState<string[]>([]);
    const [tipo_representacao_selecionada, setTipo_representacao_selecionada] = useState<'Interpretado'|'Distribuído'>('Interpretado');
    const [qualidade_definicao_krigagem, setQualidade_definicao_krigagem] = useState<'Automática'|'Definição baixa'|'Definição padrão'|'Definição melhorada'>('Automática');
    const [area_talhoes, setArea_talhoes] = useState<number>(0);
    const [talhoes_filtrados, setTalhoes_filtrados] = useState<number[]>([]);
    const [agrupar_talhoes, setAgrupar_talhoes] = useState<boolean>(false);
    const [nome_safra_selecionada, setNome_safra_selecionada] = useState<string>('');
    const [exibir_lista_talhoes, setExibir_lista_talhoes] = useState<boolean>(true);

    //FUNCTIONS
    function encontrarPropriedade(buscar_nome: string) {
        const ativoSemAcentos = removerAcentos(buscar_nome);
        return function(item) {
            const nomeSemAcentos = removerAcentos(String(item?.['nome_propriedade']));
            return nomeSemAcentos.toLowerCase().includes(ativoSemAcentos.toLowerCase()) || !buscar_nome;
        }
    };

    return (
        <Tabela>
            <Input
                placeholder='Buscar por propriedade'
                value={buscar_propriedade}
                onChange={setBuscar_propriedade}
            />

            <Render condition={carregando_pedidos}>
                <Carregando 
                    animation
                    height={500}
                    legenda={'Carregando propriedades...'}
                    justifyContent="center"
                />
            </Render>

            <Render condition={!carregando_pedidos}>
                <HeaderTable 
                    itens={[
                        {valor:'Safra', width: 181}, 
                        {valor:'Propriedade', width: 'calc(100% - 642px)'}, 
                        {valor:'Qtde talhões', width: 130.5}, 
                        {valor:'Área talhões', width: 129.5}, 
                        {valor:'Talhões', width: 90.5}, 
                        {valor:'Ações', width: 110}
                    ]}
                />

                <BodyTable style={{marginTop: -15}} >
                    {(lista_propriedades ?? []).filter(encontrarPropriedade(buscar_propriedade)).map(({ safra, nome_propriedade, qtd_talhoes, area_talhoes, coordenadas_talhoes, 
                    cod_propriedades, lista_talhoes, calcario_propriedade }, index)=> {
        
                        return (
                            <RowTable 
                                key={cod_propriedades}
                                onDoubleClick={()=>{
                                    setCod_propriedade_selecionada(cod_propriedades);
                                    setNome_propriedade_selecionada(nome_propriedade);
                                    setNome_calcario_propriedade(calcario_propriedade)
                                    setTalhoes_selecionados(lista_talhoes);
                                    setNome_safra_selecionada(safra);
                                    setArea_talhoes(area_talhoes);
                                    setOpen_modal(true);
                                }}
                            >
                                <RowItem width={180}>
                                    {safra}
                                </RowItem>
                                <RowItem width={'calc(100% - 640px)'}>
                                    { nome_propriedade }
                                </RowItem>
                                <RowItem width={130}>
                                    {qtd_talhoes}
                                </RowItem>
                                <RowItem width={130}>
                                    {area_talhoes} ha
                                </RowItem>
                                <RowItem width={90}>
                                    <SvgAgrupados 
                                        coordinates={coordenadas_talhoes}
                                        fill="var(--primary-color)"
                                    />
                                </RowItem>
                                <RowItem width={110}>
                                    <ButtonCustom 
                                        icon={<FontAwesomeIcon icon={faEye} />}
                                        onClick={()=>{
                                            setCod_propriedade_selecionada(cod_propriedades);
                                            setNome_propriedade_selecionada(nome_propriedade);
                                            setNome_calcario_propriedade(calcario_propriedade)
                                            setTalhoes_selecionados(lista_talhoes);
                                            setNome_safra_selecionada(safra);
                                            setArea_talhoes(area_talhoes);
                                            setOpen_modal(true);
                                        }}
                                    >
                                        Abrir
                                    </ButtonCustom>
                                </RowItem>
                            </RowTable>
                        )
                    })}
                    <Render condition={lista_propriedades.length === 0 && !carregando_pedidos}>
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={<> Nenhum registro disponível!</>}
                        />
                    </Render>
                </BodyTable>
            </Render>

            <Modal
                title={`Gerar book agrupado - (${nome_propriedade_selecionada})`}
                open={open_modal}
                onCancel={()=>setOpen_modal(false)}
                width={970}
                footer={false}
                destroyOnClose
                style={{marginTop: -40}}
            >
                <ModalGerarBookFertilidadeResumido 
                    cod_propriedade={cod_propriedade_selecionada}
                    lista_talhoes={talhoes_selecionados}
                    setOpen_gaveta_book={setOpen_gaveta_book}
                    setLista_dados_os={setLista_dados_os}
                    setCods_elementos_selecionados={setCods_elementos_selecionados}
                    setProfundidades_filtrar_selecionadas={setProfundidades_filtrar_selecionadas}
                    setTipo_representacao_selecionada={setTipo_representacao_selecionada}
                    setQualidade_definicao_krigagem={setQualidade_definicao_krigagem}
                    setTalhoes_filtrados={setTalhoes_filtrados}
                    agrupar_talhoes={agrupar_talhoes}
                    setAgrupar_talhoes={setAgrupar_talhoes}
                />
            </Modal>

            <DrawerCustom
                open={open_gaveta_book}
                onClose={setOpen_gaveta_book}
                width={'228mm'}
                actions={
                    <HeaderBook 
                        exibir_terreno={exibir_terreno}
                        setExibir_terreno={setExibir_terreno}
                        nome_safra_selecionada={nome_safra_selecionada}
                        exibir_lista_talhoes={exibir_lista_talhoes}
                        setExibir_lista_talhoes={setExibir_lista_talhoes}
                    />
                }
            >
                <BookFertilidadeResumidoSeparado
                    open={open_gaveta_book}
                    exibir_terreno={exibir_terreno}
                    lista_dados_os={lista_dados_os}
                    talhoes_selecionados={talhoes_selecionados}
                    nome_propriedade_selecionada={nome_propriedade_selecionada}
                    nome_calcario_propriedade={nome_calcario_propriedade}
                    tipo_representacao={tipo_representacao_selecionada}
                    cods_elementos_selecionados={cods_elementos_selecionados}
                    profundidades_filtrar_selecionadas={profundidades_filtrar_selecionadas}
                    qualidade_definicao_krigagem={qualidade_definicao_krigagem}
                    area_talhoes={Number(area_talhoes)}
                    talhoes_filtrados={talhoes_filtrados}
                    nome_safra_selecionada={nome_safra_selecionada}
                    exibir_lista_talhoes={exibir_lista_talhoes}
                />
            </DrawerCustom>
                
        </Tabela>
    )
}  